import { ReactElement, useCallback, useMemo } from "react"
import { Button, Typography, useTheme } from "@mui/material"
import DoDisturbOnRoundedIcon from "@mui/icons-material/DoDisturbOnRounded"

import { getIcon } from "utils/icon"
import { useTranslation } from "providers/i18n"
import { BaseRestrictContentPrompt } from "./BaseRestrictContentPrompt"

export const RestrictContentPrompt = ({ open = false, ...props }) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const { titleText, bodyText, actionButton, icon } =
    theme.components[`RestrictContentPrompt`]?.styleOverrides || {}

  const media = useMemo(
    () =>
      getIcon(theme?.assets?.geoGuard?.contentRestrict, icon) || (
        <DoDisturbOnRoundedIcon sx={icon} />
      ),
    [icon, theme]
  )

  const handleRefresh = useCallback(() => {
    window.location.reload()
  }, [])

  return (
    <BaseRestrictContentPrompt
      open={open}
      {...props}
      title={
        <Typography sx={titleText} variant="h6">
          {t("Oops!")}
        </Typography>
      }
      media={media as ReactElement}
      body={
        <>
          <Typography sx={bodyText} variant="body2">
            {t(
              "It looks like you're in a restricted area for this content. Try moving closer to an allowed location, then refresh this page."
            )}
          </Typography>
        </>
      }
      actionFooter={
        <>
          <Button sx={actionButton} variant="contained" onClick={handleRefresh}>
            {t("Refresh")}
          </Button>
        </>
      }
    />
  )
}
